import { useState } from 'react'
import { useParams } from 'react-router-dom'
import ModalImageSelected from './ModalImageSelected'
import UploadImgProyecto from './UploadImgProyecto'
import {
  useGetSingleProjectByUserAdmin,
  useUpdateImageProject,
} from 'lib/react-query/queriesProject'
import { useAuth0 } from '@auth0/auth0-react'
import DisabledButton from './DisabledButton'
// import ButtonOnOff from './ButtonOnOff'

const EditImageProyecto = () => {
  const [previewImage, setPreviewImage] = useState(null)
  const { idProject } = useParams()
  const { user } = useAuth0()
  const { data } = useGetSingleProjectByUserAdmin(user.sub, idProject)
  const handleOnClosePreview = () => {
    setPreviewImage(null)
  }
  const { mutateAsync } = useUpdateImageProject(idProject, handleOnClosePreview)
  const handleImageChange = event => {
    const file = event.target.files[0]
    event.target.value = null
    
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreviewImage(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }
  
  return (
    <div>
    <div className="container-upload-image">
      {previewImage && (
        <ModalImageSelected
          preview={previewImage}
          handleOnClose={handleOnClosePreview}
          onConfirm={mutateAsync}
        />
      )}
      <div className="image-project-container">
        {data.data.image ? (
          <>
            <img
              alt="proyecto"
              className="image-project"
              src={data.data.image || null}
            ></img>
            <div className="upload-image-hover">
              <UploadImgProyecto handleImageChange={handleImageChange} />
            </div>
          </>
        ) : (
          <UploadImgProyecto handleImageChange={handleImageChange} />
        )}
      </div>
    </div>
    <br />
          <DisabledButton/>
          {/* <ButtonOnOff /> */}
    </div>
  )
}

export default EditImageProyecto
